import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { SortUtils } from '../utils/sort-utils';
import { Observable } from 'rxjs';
import { UsersService } from '../services/users.service';
import { User } from '../domain/users/user.model';

@Component({
  selector: 'cm-user-email-autocomplete',
  template: `
    <mat-form-field [floatLabel]="floatLabel || 'always'" class="w-100">
      <mat-label>{{label || 'Choose user'}}</mat-label>
      <input matInput placeholder="{{placeholder}}"
             aria-label="User"
             [matAutocomplete]="auto"
             [formControl]="filterCtrl"
             [required]="isRequired">
      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="optionSelected($event)"
                        [displayWith]="display">
        <mat-option *ngFor="let user of filteredItems | async" [value]="user">
          {{user.email}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  `,
})
export class UserEmailAutocompleteComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  placeholder: string;

  @Input()
  floatLabel: string;

  @Input()
  publisherId: string;

  @Input()
  isRequired: boolean;

  @Input()
  initialEmail: string;

  @Input()
  filterRoles: string[];

  @Output()
  itemSelected = new EventEmitter<User>();

  @Output()
  userListAcquired = new EventEmitter<User[]>();

  items: User[] = [];
  filteredItems: Observable<User[]>;
  filterCtrl = new FormControl();
  selectedItem;

  constructor(private service: UsersService) {
    this.filteredItems = this.filterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(item => {
          if (typeof item !== 'object') {
            return this.items.filter(p => p.email.toLowerCase().includes(item.toLowerCase())).slice(0, 5);
          } else {
            return this.items.slice(0, 5);
          }
        })
      );
    this.filterCtrl.valueChanges.subscribe(next => {
      if (!next && this.selectedItem) {
        this.selectedItem = undefined;
        this.emit();
      }
    });
  }


  ngOnInit() {
    this.refreshData(true);
  }

  // we can call method outside after enter new user in order to reload data
  refreshData(initialLoad?: boolean) {
    const observable = this.publisherId ? this.service.getByPublisherId(this.publisherId) : this.service.getUsers();

    observable.subscribe(next => {
      this.items = next || [];
      if (this.filterRoles && this.filterRoles.length) {
        this.items = this.items.filter(i => i.roles.some(role => this.filterRoles.includes(role)));
      }
      this.items.sort(SortUtils.propertyComparatorString('email'));
      this.userListAcquired.emit(this.items);

      if (initialLoad) {
        this.checkForInitialSelect();
      }
    });
  }

  checkForInitialSelect() {
    if (this.initialEmail) {
      const findItem = this.items.find(item => item.email === this.initialEmail);
      this.filterCtrl.setValue(findItem);
      this.selectedItem = findItem;
    }
  }

  display(u?: User) {
    return u ? u.email : undefined;
  }

  resetInput() {
    this.selectedItem = null;
    this.filterCtrl.setValue(null);
  }

  optionSelected($event) {
    this.selectedItem = $event.option.value;
    this.emit();
  }

  private emit() {
    this.itemSelected.emit(this.selectedItem);
  }

}
